export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('COMPANY_LOCAL_TAX_DEFAULT_PRODUCT_NULL') === 0) {
      messages.push({
        message: 'declarationTlpe.messages.errors.noProduitReglementTlpe',
      });
    }
  });
}
